import { createSlice, isAnyOf } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

import { api as frontendApi } from '@/redux/apis/frontend-api';

type SetCountryAction = PayloadAction<string[]>;
type SetLocationAction = PayloadAction<string[]>;
type SetSiteAction = PayloadAction<string[]>;
type SetCommunicationPurpose = PayloadAction<string[]>;
type SetSubcategory = PayloadAction<string[]>;
type SetComponentAction = PayloadAction<string[]>;
type SetDepartmentAction = PayloadAction<string[]>;
type SetCarrierTypeAction = PayloadAction<string[]>;
type SetCarrierSizeAction = PayloadAction<string[]>;
type SetOnlyMyCodesAction = PayloadAction<boolean>;
type SetFiltersAction = PayloadAction<CodeFiltersState>;
// type SetDateAction = PayloadAction<{
//   from?: number;
//   to?: number;
// }>;

// Define a type for the slice state
export type CodeFiltersState = {
  location: string[];
  country: string[];
  site: string[];
  communicationPurpose: string[];
  subcategory: string[];
  component: string[];
  department: string[];
  carrierType: string[];
  carrierSize: string[];
  onlyMyCodes: boolean;
  // date: {
  //   from?: number;
  //   to?: number;
  // };
};

// Define the initial state using that type
const initialState: CodeFiltersState = {
  location: [],
  country: [],
  site: [],
  communicationPurpose: [],
  subcategory: [],
  component: [],
  department: [],
  carrierType: [],
  carrierSize: [],
  onlyMyCodes: true,
  // date: {},
};

export const codeFiltersSlice = createSlice({
  name: 'codeFilters',

  initialState,

  reducers: {
    setLocation(state, action: SetLocationAction) {
      state.location = action.payload;
    },

    setCountry(state, action: SetCountryAction) {
      state.country = action.payload;
    },

    setSite(state, action: SetSiteAction) {
      state.site = action.payload;
    },

    setCommunicationPurpose(state, action: SetCommunicationPurpose) {
      state.communicationPurpose = action.payload;
    },

    setSubcategory(state, action: SetSubcategory) {
      state.subcategory = action.payload;
    },

    setComponent(state, action: SetComponentAction) {
      state.component = action.payload;
    },

    setDepartment(state, action: SetDepartmentAction) {
      state.department = action.payload;
    },

    setCarrierType(state, action: SetCarrierTypeAction) {
      state.carrierType = action.payload;
    },

    setCarrierSize(state, action: SetCarrierSizeAction) {
      state.carrierSize = action.payload;
    },

    setOnlyMyCodes(state, action: SetOnlyMyCodesAction) {
      state.onlyMyCodes = action.payload;
    },

    // setDate(state, action: SetDateAction) {
    //   state.date.from = action.payload.from;
    //   state.date.to = action.payload.to;
    // },

    setFilters(state, action: SetFiltersAction) {
      Object.assign(state, action.payload);
    },

    reset(state: CodeFiltersState) {
      return { ...initialState };
    },
  },

  extraReducers: (builder) => {
    // Set country when user is logged in
    builder.addMatcher(
      isAnyOf(frontendApi.endpoints.getV1UsersMe.matchFulfilled),
      (state, action) => {
        if (action.payload) {
          state.country = [action.payload.country?.toLowerCase()];
          state.site = [action.payload.cdsLocation];
        }
      }
    );
  },
});

export const {
  setLocation,
  setCountry,
  setSite,
  setCommunicationPurpose,
  setSubcategory,
  setComponent,
  setDepartment,
  setCarrierType,
  setCarrierSize,
  setOnlyMyCodes,
  // setDate,
  setFilters,
  reset,
} = codeFiltersSlice.actions;

export default codeFiltersSlice.reducer;
